import { JsonProperty } from "../../../models/utilities/json-property";

export class DealerSalesDivision {

    /** CD, OEM, RS or PMAX. */
    public division: string = '';

    /** January to December; a month with no invoices has no value. */
    public months: Array<number | null> = [];

    public total: number = 0.0;

}

export class DealerSalesYear {

    public year: number = 0;

    /** January to December; a month with no invoices has no value. */
    public months: Array<number | null> = [];

    public total: number = 0.0;

    /** The same months by the division that invoiced them, for the divisions with sales that year. */
    @JsonProperty({ toClass: DealerSalesDivision, designType: 'array' })
    public divisions: DealerSalesDivision[] = [];

}

export class DealerSalesSummary {

    /** From January 1 to today. */
    public yearToDate: number = 0.0;

    /** From January 1 of last year to the same day last year. */
    public sameDaysLastYear: number = 0.0;

    /** The year up to and including today. */
    public last12Months: number = 0.0;

}

export class DealerDivisionOrdering {

    /** The day of the last order the dealer entered, whenever that was. */
    @JsonProperty({ toType: 'date' })
    public lastOrderDate: Date | undefined = undefined;

    /** Days from one order to the next since the averages begin; none with fewer than two orders. */
    public averageDaysBetweenOrders: number | null = null;

}

export class DealerOrdering {

    @JsonProperty({ toClass: DealerDivisionOrdering })
    public completeDoor: DealerDivisionOrdering = new DealerDivisionOrdering();

    @JsonProperty({ toClass: DealerDivisionOrdering })
    public rollingSteel: DealerDivisionOrdering = new DealerDivisionOrdering();

}

export class DealerSales {

    public dealerId: string = '';

    /** The newest year first. */
    @JsonProperty({ toClass: DealerSalesYear, designType: 'array' })
    public years: DealerSalesYear[] = [];

    @JsonProperty({ toClass: DealerSalesSummary })
    public summary: DealerSalesSummary = new DealerSalesSummary();

    @JsonProperty({ toClass: DealerOrdering })
    public ordering: DealerOrdering = new DealerOrdering();

}
